import React from 'react';
import {IconNames} from '@blueprintjs/icons';

import {NoResult} from '../../list';

interface NoSourceBlockProps {
}

export const NoSourceBlock = (props: NoSourceBlockProps) => {
  return (
    <NoResult
      className="no-source-block"
      icon={IconNames.DATABASE}
      title="No Source Content found."
      description="Please create a SQL Content first."
    />
  );
}

export default NoSourceBlock;
